import { Component } from "@angular/core";
import { UserRepositoryService } from "../services/user-repository.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { sectionDetails } from "../shared/models/admin.model";
import { AdminRepositoryService } from "../services/admin-repository.service";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent {
  pageContents: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  isLoadingData: boolean = true;
  isPageReadyToDisplay: boolean = false;
  constructor(
    private userRepository: UserRepositoryService,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private adminRepository: AdminRepositoryService
  ) {}

  ngOnInit() {
    this.getHomePageContents();

    this.msalBroadcastService.msalSubject$.subscribe({
      next: (msalSubject) => {
        console.log(msalSubject.eventType);
        if (msalSubject.eventType === 'msal:acquireTokenFailure') {
          // alert('From home')
          this.msalService.logout();
        }
      }
    });
  }

  getHomePageContents() {
    this.isLoadingData = true;
    this.userRepository
      .getHomePageContents()
      //this.adminRepository.getAllHomePageConents('HomeSectionsManagement')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((homePageContents) => {
        if (homePageContents) {
          this.isPageReadyToDisplay = true;
          this.pageContents = homePageContents;
          this.isLoadingData = false;
        }
        
      },
      (error: any) => {
          console.log('Error loading HomePage Contents:', error);
          this.isLoadingData = false;
      }
    );
  }
  
}
